<template>
    <aside class="minicart">
        <div
            v-if="motivationPopoverContent"
            v-html="motivationPopoverContent"
        />
        <div class="container" data-element="sticky-cart">
            <div class="uppercase bold hidden-md-down">ТЕКУЩИЙ ЗАКАЗ</div>
            <hr class="hidden-md-down mt-xs mb-2">
            <div class="minicart-slideup js-minicart-slideup fade-out">
                <transition-group name="slide-fade" tag="div">
                    <MiniCartGroup
                        :group="group"
                        :key="group.type"
                        v-for="group in displayGroups"
                        @remove="(item) => remove(item)"
                     />
                </transition-group>
                <hr class="mt-2 mb-2">
            </div>
            <div class="row v-centered">
                <div class="col-sm-8 col-lg-12">
                    <div class="minicart-detailed">
                        <span class="fs-sm text-silver mr-4">
                            <span>Разовый платеж:&nbsp;</span>
                            <span class="nowrap">
                                <s class="fs-sm text-grey"
                                   data-element="mini-cart-price-once-full"
                                   v-if="total.priceOnceFull > total.priceOnce"
                                >{{ formatPrice(total.priceOnceFull) }}</s>&nbsp;<span
                                class="nowrap mini-basket-price"
                                :class="{'text-orange': total.priceOnceFull > total.priceOnce}"
                                data-element="mini-cart-price-once"
                            >{{ formatPrice(total.priceOnce) }}</span>
                                <span>&nbsp;руб.</span>
                            </span>
                        </span>
                        <span class="fs-sm text-silver">
                            <span>Ежемесячно:&nbsp;</span>
                            <span class="nowrap">
                                <s
                                    class="fs-sm text-grey"
                                    data-element="mini-cart-price-monthly-full"
                                    v-if="total.priceMonthlyFull > total.priceMonthly"
                                >{{ formatPrice(total.priceMonthlyFull) }}</s>
                                &nbsp;
                                <span
                                    class="mini-basket-price"
                                    :class="{'text-orange': total.priceMonthlyFull > total.priceMonthly}"
                                    data-element="mini-cart-price-monthly"
                                >
                                    {{ formatPrice(total.priceMonthly) }}
                                </span>
                                <span>&nbsp; руб.</span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row v-centered">
                <div class="col-sm-4 col-lg-12 t-right">
                    <Button
                        size="md"
                        color="orange"
                        title="Продолжить"
                        :loading="loading"
                        @click="$emit('submit')"
                    />
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
import MiniCartGroup from './MiniCartGroup'
import Button from '../../../components/ui/Button'
import ModelCart from '../models/cart';
import priceFormatter from '../../../lib/priceFormatter.js'

export default {
    name: "MiniCart",
    components: {
        MiniCartGroup,
        Button
    },
    props: {
        cart: {
            type: ModelCart
        },
        motivationPopoverContent: {
            type: String
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayGroups () {
            return this.cart.groups.filter(group => !group.isHidden && group.items.length > 0)
        },
        total () {
            let total = {
                priceOnce: 0,
                priceOnceFull: 0,
                priceMonthly: 0,
                priceMonthlyFull: 0,
                total: 0
            };

            this.cart.groups.forEach((group) => {
                group.items.forEach((item) => {
                    total.priceOnce += item.priceOnce;
                    total.priceOnceFull += item.priceOnceFull;
                    total.priceMonthly += item.priceMonthly;
                    total.priceMonthlyFull += item.priceMonthlyFull;
                })
            });

            total.total = total.priceOnce + total.priceMonthly

            return total
        }
    },
    methods: {
        formatPrice (price) {
            return priceFormatter.format(price)
        },
        remove (item) {
            this.$emit('remove', item);
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/transition/slide-fade';
</style>